import * as React from 'react';
import * as _ from 'underscore';

import { CollectionSpaceHeaderProps } from './CollectionSpaceHeader';
import { CollectionsResourceQuery, UpdateCollectionData } from './ResourceQuery/CollectionsResourceQuery';
import { InlineEditableDescriptionProps, InlineEditableDescription } from '../Header/InlineEditableDescription';
import { COLLECTION_DESCRIPTION_MAX_LENGTH } from '../../content/contentDetailDialog/DescriptionDetailSection';
import { UpdateCollectionsResponseData } from './CollectionModels';
import { Messages } from '~src/codegen/Localize';

export interface EditableCollectionDescriptionInlineProps extends CollectionSpaceHeaderProps {
  readonly canEdit: boolean;
  readonly onEditChange: (isEditing: boolean) => void;
}

export function EditableCollectionDescriptionInline(props: EditableCollectionDescriptionInlineProps): JSX.Element {
  const updateDescription = React.useCallback(
    async (description: string): Promise<void> => {
      const updatedCollectionData: UpdateCollectionData = {
        luid: props.item.luid,
        description: description
      };
      const response: UpdateCollectionsResponseData = await (new CollectionsResourceQuery()).update([updatedCollectionData]);
      if (response.errors && response.errors.length > 0) {
        throw {
          data: [{errorCode: response.errors[0].errorCode}]
        };
      }
      props.reloadSpace();
    },[props.item.luid]
  );


  const descriptionProps: InlineEditableDescriptionProps = {
    ...props,
    maxCharacterCount: COLLECTION_DESCRIPTION_MAX_LENGTH,
    updateDescription: updateDescription,
    sanitizer: props.sanitizer,
    canEdit: props.isAdminOrOwner && props.canEdit,
    onEditChange: props.onEditChange,
    ariaLabel: Messages.collectionDescriptionTextAreaLabel(),
  };

  return <InlineEditableDescription {...descriptionProps} />;
}
